import { useEffect } from "react";
import { getCookieConsent } from "@/components/CookieBanner";

/**
 * Loads Google Analytics 4, Microsoft Clarity and Google Search Console verification
 * only after the user has accepted cookies AND the corresponding environment variable
 * is configured. IDs are NEVER hardcoded.
 *
 * Configure (frontend/.env):
 *   REACT_APP_GA4_ID            = G-XXXXXXX           (Google Analytics 4)
 *   REACT_APP_CLARITY_ID        = abcd1234             (Microsoft Clarity)
 *   REACT_APP_GSC_VERIFICATION  = google-site-verification-token
 */
export default function AnalyticsLoader() {
  useEffect(() => {
    const load = () => {
      if (getCookieConsent() !== "accepted") return;

      const ga = process.env.REACT_APP_GA4_ID;
      if (ga && !document.getElementById("stenzia-ga4")) {
        const s = document.createElement("script");
        s.id = "stenzia-ga4";
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
        document.head.appendChild(s);

        const init = document.createElement("script");
        init.id = "stenzia-ga4-init";
        init.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga}',{anonymize_ip:true});`;
        document.head.appendChild(init);
      }

      const clarity = process.env.REACT_APP_CLARITY_ID;
      if (clarity && !document.getElementById("stenzia-clarity")) {
        const s = document.createElement("script");
        s.id = "stenzia-clarity";
        s.text = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","${clarity}");`;
        document.head.appendChild(s);
      }
    };

    // GSC verification meta — safe to render regardless of consent (no PII)
    const gsc = process.env.REACT_APP_GSC_VERIFICATION;
    if (gsc && !document.querySelector('meta[name="google-site-verification"]')) {
      const m = document.createElement("meta");
      m.setAttribute("name", "google-site-verification");
      m.setAttribute("content", gsc);
      document.head.appendChild(m);
    }

    load();
    const onConsent = () => load();
    window.addEventListener("stenzia:consent", onConsent);
    return () => window.removeEventListener("stenzia:consent", onConsent);
  }, []);

  return null;
}
